const recaptcha = () => ({
  url: '/recaptcha/siteverify',
  key: process.env.REACT_APP_KEY_RECAPTCHA
});

export default recaptcha;
